export default "__VITE_ASSET__DD7cADIo__"